export const ownershipConstants = {
    errors: {
        fetchFailed: "Failed to load ownership data.",
        leaderboardFailed: "Failed to load contributors leaderboard.",
        statsFailed: "Failed to load ownership stats.",
        genericError: "Something went wrong.",
    },
};

export const featuresConstants = {
    errors: {
        fetchFailed: "Failed to load features.",
        createFailed: "Failed to create feature.",
        updateFailed: "Failed to update feature.",
        deleteFailed: "Failed to delete feature.",
        linkFailed: "Failed to link tasks.",
        unlinkFailed: "Failed to unlink task.",
    },
    messages: {
        createSuccess: "Feature created.",
        updateSuccess: "Feature updated.",
        deleteSuccess: "Feature deleted.",
    },
};
